const CopyrightFooter = () => {
  return (
    <div
      className="copyright-text"
      style={{ backgroundColor: "var(--primary-light-color)" }}
    >
      <p>
        © {new Date().getFullYear()} Jandi by{" "}
        <a
          href="https://www.softwareontheroad.com/es/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Software On The Road
        </a>
        . All Right Reserved.
      </p>
    </div>
  );
};

export default CopyrightFooter;
